/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowShapeTriangleARightIcon20Regular = forwardRef('ArrowShapeTriangleARightIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 5.38a1.35 1.35 0 0 1 2.106-1.118l6.83 4.62a1.35 1.35 0 0 1 0 2.236l-6.83 4.62A1.35 1.35 0 0 1 6 14.62V5.38Zm1.5.283v8.675L13.912 10 7.5 5.663Z" })));
});
